import { Profile } from "types/Profile";
import { BaseService, ResponseData } from "./baseService";

class ProfileService extends BaseService<Profile> {
  controllerName = "profile";

  async getFilterRoleMembers(id: string | number): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();
    const { data } = await this.api.get(
      `/${this.controllerName}/membersRole/:${id}`
    );
    return data;
  }

  async addFilterRoleMembers(
    filterRoleId: string | number,
    membersIds: number[]
  ): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();
    const { data } = await this.api.patch(
      `/${this.controllerName}/addMembers`,
      {
        filterRoleId,
        membersIds,
      }
    );
    return data;
  }
}

export const profileService = new ProfileService();
